/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Trust_UpdatedInputs */

const en_directory_home_trust_updated = /** @type {(inputs: Directory_Home_Trust_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated weekly`)
};

const zh_directory_home_trust_updated = /** @type {(inputs: Directory_Home_Trust_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每周更新`)
};

/**
* | output |
* | --- |
* | "Updated weekly" |
*
* @param {Directory_Home_Trust_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_trust_updated = /** @type {((inputs?: Directory_Home_Trust_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Trust_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_trust_updated(inputs)
	return zh_directory_home_trust_updated(inputs)
});
export { directory_home_trust_updated as "directory.home.trust_updated" }